var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBicycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 36,
    fill: "none",
    viewBox: "0 0 56 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M43.221 11.7941L40.9879 1.23233C40.836 0.514062 40.2023 0 39.468 0H35.1167V1.55362V3.10724H38.2085L39.5201 9.31067H6.25049V12.5042C7.63742 12.023 9.1271 11.7615 10.6779 11.7615C12.1334 11.7615 13.5351 11.9918 14.8485 12.418H39.9962C41.0227 12.0849 42.1031 11.8715 43.221 11.7941ZM33.0931 17.5378L23.7438 21.8528C24.0121 22.8841 24.1616 23.9635 24.1766 25.0753L31.093 21.8831C31.4998 20.3044 32.185 18.8374 33.0931 17.5378Z",
    clipRule: "evenodd",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.3078 4.48047H10.3047V6.03409V7.58771H16.3078V6.03409V4.48047Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11 35.9578C17.0751 35.9578 22 31.0329 22 24.9578C22 18.8826 17.0751 13.9578 11 13.9578C4.92487 13.9578 0 18.8826 0 24.9578C0 31.0329 4.92487 35.9578 11 35.9578ZM11 32.9578C15.4183 32.9578 19 29.376 19 24.9578C19 20.5395 15.4183 16.9578 11 16.9578C6.58172 16.9578 3 20.5395 3 24.9578C3 29.376 6.58172 32.9578 11 32.9578ZM55.0265 24.9915C55.0265 31.0667 50.1016 35.9915 44.0265 35.9915C37.9513 35.9915 33.0265 31.0667 33.0265 24.9915C33.0265 18.9164 37.9513 13.9915 44.0265 13.9915C50.1016 13.9915 55.0265 18.9164 55.0265 24.9915ZM44.0265 32.9915C48.4447 32.9915 52.0265 29.4098 52.0265 24.9915C52.0265 20.5733 48.4447 16.9915 44.0265 16.9915C39.6082 16.9915 36.0265 20.5733 36.0265 24.9915C36.0265 29.4098 39.6082 32.9915 44.0265 32.9915Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicycle);
export default __webpack_public_path__ + "static/media/bicycle.05bd2dfe70cf4a8aa920dd3a074a96c5.svg";
export { ForwardRef as ReactComponent };